export default __webpack_public_path__ + "static/media/expresso-hero.f3f58444.mp4";